var fallbackCopyTextToClipboard = function fallbackCopyTextToClipboard(str) {
  var el = document.createElement('textarea'); // Create a <textarea> element

  el.value = str; // Set its value to the string that you want copied

  el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof

  el.style.position = 'absolute';
  el.style.left = '-9999px'; // Move outside the screen to make it invisible

  document.body.appendChild(el); // Append the <textarea> element to the HTML document

  var selected = document.getSelection().rangeCount > 0 // Check if there is any content selected previously
  ? document.getSelection().getRangeAt(0) // Store selection if found
  : false; // Mark as false to know no selection existed before

  el.focus();
  el.select(); // Select the <textarea> content

  el.setSelectionRange(0, 99999); // For mobile devices

  document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)

  document.body.removeChild(el); // Remove the <textarea> element

  if (selected) {
    // If a selection existed before copying
    document.getSelection().removeAllRanges(); // Unselect everything on the HTML document

    document.getSelection().addRange(selected); // Restore the original selection
  }
};

var selectText = function selectText(ref) {
  if (ref) {
    if (document.selection) {
      // IE
      var range = document.body.createTextRange();
      range.moveToElementText(ref);
      range.select();
    } else if (window.getSelection) {
      var _range = document.createRange();

      _range.selectNode(ref);

      window.getSelection().removeAllRanges();
      window.getSelection().addRange(_range);
    }
  }
};

var checkClipboardAccess = function checkClipboardAccess() {
  var promise = new Promise(function (resolve) {
    if (!navigator.clipboard) resolve(false);
    if (navigator.permissions) navigator.permissions.query({
      name: 'clipboard-write'
    }).then(function (result) {
      if (result.state === 'granted') resolve(true);else resolve(false);
    });else resolve(false);
  });
  return promise;
};

var copyToClipboard = function copyToClipboard(text, ref) {
  selectText(ref);
  checkClipboardAccess().then(function (canAccess) {
    if (canAccess) navigator.clipboard.writeText(text);else fallbackCopyTextToClipboard(text);
  });
};

export default copyToClipboard;